import { useSetImmerAtom } from 'jotai-immer';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { splitOrderInvoicesSearchFormAtom } from './split_order_invoices_search_atoms';
import { splitOrderInvoicesSearchStateVM } from './split_order_invoices_search_view_models';
import { getDateRangeForMode } from '../../../../core/components/validation/ValidInputDate.utils';
import { SPLIT_ORDER_INVOICES_LIST_FORM_KEY } from '../../split_order_invoices_const';
import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { splitOrderInvoicesPageActionAtom } from '../split_order_invoices_list_atoms';
import utilSvc from '../../../../core/utilSvc';
import { ngContext } from '../../../../core/services/ng.delegate';
import { ValidOption } from '../../../../core/components/validation/types';
import { useSplitOrderInvoicesStoreActions } from '../pagehooks/useSplitOrderInvoicesStore';

export const useSplitOrderInvoicesSearchInit = (): boolean => {
    const [init, setInit] = useState(true);
    const action = useAtomValue(splitOrderInvoicesPageActionAtom);
    const setSearchForm = useSetImmerAtom(splitOrderInvoicesSearchFormAtom);
    const { getList } = useSplitOrderInvoicesStoreActions();

    useEffect(() => {
        if (init && action === 'QUERY') {
            const ctx = ngContext();
            let affs = utilSvc.aff.findStatus(ctx.User?.AffList ?? []);
            affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
            affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature('invoice.split'));
            const rxDroplist = utilSvc.aff.rxDroplist(affs) ?? [];
            const rxOptions: ValidOption[] = rxDroplist.map((rx: any) => ({ lbl: rx.label, val: rx.value }));

            // If there is exactly one pharmacy available, auto-select it.
            const singleRxVal = rxOptions.length === 1 ? String(rxOptions[0].val) : '';

            const defaultRange = getDateRangeForMode('MTD');
            const vs = viewStateRepo.getForm(SPLIT_ORDER_INVOICES_LIST_FORM_KEY);

            // Prefer a saved pharmacy from viewstate, otherwise fall back to the
            // auto-selected single pharmacy (if any).
            const rxVal = vs?.RX?.val || singleRxVal;

            const vsWithOptions = {
                ...vs,
                rxOptions,
                DateRangeMode: vs?.DateRangeMode ?? 'MTD',
                StartDate: vs?.StartDate ?? defaultRange.start,
                EndDate: vs?.EndDate ?? defaultRange.end,
                RebatesOnly: vs?.RebatesOnly ?? false,
            };

            if (rxVal) {
                const ceDroplist = utilSvc.aff.ceDroplist(affs, rxVal, false, true) ?? [];
                const ceOptions: ValidOption[] = ceDroplist.map((ce: any) => ({
                    lbl: ce.value === 'ALL' ? 'All Facilities' : ce.label,
                    val: ce.value,
                }));
                const savedCeVal = vs?.CE?.val ?? '';
                vsWithOptions.RX = {
                    ...vs?.RX,
                    val: rxVal,
                };
                vsWithOptions.ceOptions = ceOptions;
                vsWithOptions.CE = {
                    ...vs?.CE,
                    val: savedCeVal || (ceOptions[0] ? String(ceOptions[0].val) : ''),
                };
            } else {
                vsWithOptions.ceOptions = [];
            }

            const formState = splitOrderInvoicesSearchStateVM(vsWithOptions);
            setInit(false);
            setSearchForm(() => formState);

            // auto-search on return visit if viewstate exists
            if (vs?.RX?.val) {
                getList(formState);
            }
        }
        /* eslint-disable-next-line */
    }, []);

    return init;
};
